import {
	listReports, reviewReport,
	listReportCategories, createReportCategory, updateReportCategory, deleteReportCategory,
} from '@/services/academy/reports.service'

export default {
	namespaced: true,
	state: {
		list:           { data: [], meta: { pagination: { total: 0, count: 0, per_page: 20, current_page: 1, total_pages: 1 } } },
		listStatus:     'init',
		categories:     [],
		catStatus:      'init',
	},
	getters: {
		getList:       (s) => s.list,
		getListStatus: (s) => s.listStatus,
		getCategories: (s) => s.categories,
		getCatStatus:  (s) => s.catStatus,
	},
	mutations: {
		SET_LIST(state, v)       { state.list = v },
		SET_LIST_STATUS(state, v){ state.listStatus = v },
		SET_CATEGORIES(state, v) { state.categories = v },
		SET_CAT_STATUS(state, v) { state.catStatus = v },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await listReports(params)
				commit('SET_LIST', data)
				commit('SET_LIST_STATUS', 'init')
			} catch {
				commit('SET_LIST_STATUS', 'error')
			}
		},
		async review({ dispatch }, data) {
			await reviewReport(data)
			dispatch('fetchList')
		},
		async fetchCategories({ commit }) {
			commit('SET_CAT_STATUS', 'pending')
			try {
				const { data } = await listReportCategories()
				commit('SET_CATEGORIES', data.data || [])
				commit('SET_CAT_STATUS', 'init')
			} catch {
				commit('SET_CAT_STATUS', 'error')
			}
		},
		async createCategory({ dispatch }, data) {
			await createReportCategory(data)
			dispatch('fetchCategories')
		},
		async updateCategory({ dispatch }, data) {
			await updateReportCategory(data)
			dispatch('fetchCategories')
		},
		async removeCategory({ dispatch }, id) {
			await deleteReportCategory(id)
			dispatch('fetchCategories')
		},
	},
}
